import z from 'zod';

/**
 * Job input for SEED_QUESTION_VARIANT_GENERATION.
 * Used as the `data` payload (JSON string) when creating a seed question variant job.
 */
export const seedQuestionVariantJobDataSchema = z.object({
  moduleId: z.string().min(1, 'Module ID is required'),
  seedQuestionCount: z.number().int().min(1, 'At least one seed question is required'),
  variantsPerSeed: z.number().int().min(1, 'At least one variant per seed is required').default(5),
  runLimit: z.number().int().min(1).max(1000).optional(),
});

export interface SeedQuestionVariantJobData extends z.infer<typeof seedQuestionVariantJobDataSchema> {}
/** Single task item within seed question variant job metadata (server-populated). */
export const seedQuestionVariantJobTaskSchema = z.object({
  seedQuestionId: z.string().min(1),
  topic: z.string().min(1),
  variantsPerSeed: z.number().int().min(1),
});

export interface SeedQuestionVariantJobTask extends z.infer<typeof seedQuestionVariantJobTaskSchema> {}
export function validateSeedQuestionVariantJobData(data: string): SeedQuestionVariantJobData {
  return seedQuestionVariantJobDataSchema.parse(JSON.parse(data));
}
